<template>
  <div class="card card-body">
    <div class="form-group">
      <label>{{ 'customer_type' | t }}</label>
      <select class="form-control" v-model="customer_type" required="required">
        <option v-for="ct in customer_types" :value="ct">{{ ct | t }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>{{ 'country' | t }}</label>
      <select class="form-control" v-model="customer.country_code" required="required">
        <option v-for="c in countries" :value="c.code">{{ c.name }}</option>
      </select>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'vat_no' | t }}</label>
          <input class="form-control" placeholder="Vat" v-model="customer.vat_no" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'ean_no' | t }} ({{ 'optional' | t }})</label>
          <input class="form-control" :placeholder="$t('ean_no')" v-model="customer.ean" />
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group">
      <label>{{ 'company_name' | t }}</label>
      <input class="form-control" :placeholder="$t('company_name')" v-model="customer.name" />
    </div>
    <div class="form-group">
      <label>{{ 'address' | t }}</label>
      <input class="form-control" :placeholder="$t('address_1')" v-model="customer.address_1" />
      <input class="mt-2 form-control" :placeholder="$t('address_2')" v-model="customer.address_2" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>{{ 'zip' | t }}</label>
          <input class="form-control" :placeholder="$t('zip')" v-model="customer.zip" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="form-group">
          <label>{{ 'city' | t }}</label>
          <input class="form-control" :placeholder="$t('city')" v-model="customer.city" />
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group">
      <label>{{ 'tenant_name' | t }}</label>
      <input class="form-control" :placeholder="$t('tenant_name')" v-model="customer.tenant_name" />
    </div>
    <div class="form-group">
      <label>{{ 'admin_contact' | t }}</label>
      <div class="form-group">
        <label>{{ 'name' | t }}</label>
        <input class="form-control" :placeholder="$t('name')" v-model="customer.admin_contact_name" />
      </div>
      <div class="form-group">
        <label>{{ 'phone' | t }}</label>
        <input class="form-control" :placeholder="$t('phone')" v-model="customer.admin_contact_phone" />
      </div>
      <div class="form-group">
        <label>{{ 'email' | t }}</label>
        <input class="form-control" :placeholder="$t('email')" v-model="customer.admin_contact_email" />
      </div>
    </div>
    <div class="form-group">
      <checkbox v-model="use_admin_for_billing">
        <label>{{ 'use_admin_for_billing' | t }}</label>
      </checkbox>
    </div>
    <div class="form-group" v-if="!use_admin_for_billing">
      <label>{{ 'billing_contact' | t }}</label>
      <div class="form-group">
        <label>{{ 'name' | t }}</label>
        <input class="form-control" :placeholder="$t('name')" v-model="customer.billing_contact_name" />
      </div>
      <div class="form-group">
        <label>{{ 'phone' | t }}</label>
        <input class="form-control" :placeholder="$t('phone')" v-model="customer.billing_contact_phone" />
      </div>
      <div class="form-group">
        <label>{{ 'email' | t }}</label>
        <input class="form-control" :placeholder="$t('email')" v-model="customer.billing_contact_email" />
      </div>
    </div>
    <div class="form-group">
      <div class="label">{{ 'domain' | t }} ({{ 'optional' | t }}) - {{ 'domain_description' | t }}</div>
      <input class="form-control" :placeholder="$t('domain')" v-model="domains" />
    </div>
  </div>
</template>
<script>
import config from '@/config';
import Alerts, { handle } from '@/utils/alerts';

let global_countries = require('i18n-iso-countries');

export default {
  props: {
    value: {
      type: Object
    }
  },
  data: function () {
    return {
      use_admin_for_billing: true,
      previous_conditions_met: false
    };
  },
  computed: {
    customer() {
      return this.value;
    },
    countries() {
      var cs = global_countries.getNames(config.locale);
      return _.chain(cs)
        .map((name, code) => {
          return { code: code, name: name };
        })
        .sortBy(['name', 'asc'])
        .unshift({ code: '', name: '' })
        .unshift({ code: 'DK', name: cs.DK })
        .unshift({ code: 'GB', name: cs.GB })
        .value();
    },
    customer_types() {
      return this.$attrs.customer_types;
    },
    customer_type: {
      get() {
        switch (this.customer.service_status) {
          case 'running':
            switch (this.customer.onboarding_status) {
              case 'onboarding':
                return 'onboarding';
              case 'migrating':
                return 'migrating';
              case 'onboarded':
              default:
                return 'active';
            }
          case 'blocked':
            return 'blocked';
          case 'disabled':
            if (this.customer.onboarding_status == 'cancelled') {
              return 'cancelled';
            } else {
              return 'blocked';
            }
          case 'test':
            return 'test';
          default:
            return null;
        }
      },
      set: handle(function (new_customer_type) {
        if (!this.customer_types.includes(new_customer_type)) {
          throw `${this.$t('unsupported')} ${this.$t('customer_type')}: ${new_customer_type}`;
        }
        switch (new_customer_type) {
          // ["running,onboarded,active", 293],	 	(Active)
          // ["running,onboarding,active", 221],	 (Onboarding)
          // ["test,demo,trial", 192],  			 (Test)
          // ["disabled,cancelled,cancelled", 147],  (Cancelled)
          // ["running,migrating,active", 17],		(Migrating)
          // ["blocked,onboarded,active", 1],		(Blocked)

          case 'active':
            this.customer.service_status = 'running';
            this.customer.onboarding_status = 'onboarded';
            this.customer.quote.status = 'active';
            break;
          case 'blocked':
            this.customer.service_status = 'blocked';
            this.customer.onboarding_status = 'onboarded';
            this.customer.quote.status = 'active';
            break;
          case 'cancelled':
            this.customer.service_status = 'disabled';
            this.customer.onboarding_status = 'cancelled';
            this.customer.quote.status = 'cancelled';
            break;
          case 'test':
            this.customer.service_status = 'test';
            this.customer.onboarding_status = 'demo';
            this.customer.quote.status = 'trial';
            break;
          case 'migrating':
            this.customer.service_status = 'running';
            this.customer.onboarding_status = 'migrating';
            this.customer.quote.status = 'active';
            break;
          case 'onboarding':
            this.customer.service_status = 'running';
            this.customer.onboarding_status = 'onboarding';
            this.customer.quote.status = 'active';
            break;
        }
      })
    },
    conditions_met() {
      return (
        this.customer &&
        this.present(this.customer.address_1) &&
        this.present(this.customer.admin_contact_name) &&
        this.present(this.customer.admin_contact_email) &&
        this.present(this.customer.admin_contact_phone) &&
        this.present(this.customer.billing_contact_name) &&
        this.present(this.customer.billing_contact_email) &&
        this.present(this.customer.billing_contact_phone) &&
        this.present(this.customer.city) &&
        this.present(this.customer.country_code) &&
        this.present(this.customer.zip) &&
        this.present(this.customer_type) &&
        this.present(this.customer.name) &&
        this.present(this.customer.tenant_name) &&
        this.present(this.customer.vat_no)
      );
    },
    domains: {
      get() {
        return this.customer.domains && this.customer.domains.join(', ');
      },
      set(domains) {
        this.customer.domains = domains ? domains.split(',').map((dom) => dom.trim()) : [];
      }
    }
  },
  mounted() {
    if (this.conditions_met) {
      this.$emit('conditions_met', 'company');
    }
  },
  methods: {
    present(string) {
      return string && string.trim().length > 0;
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    }
  },
  watch: {
    use_admin_for_billing() {
      if (this.use_admin_for_billing) {
        this.customer.billing_contact_name = this.customer.admin_contact_name;
        this.customer.billing_contact_phone = this.customer.admin_contact_phone;
        this.customer.billing_contact_email = this.customer.admin_contact_email;
      }
    },
    'customer.admin_contact_name'() {
      if (this.use_admin_for_billing) {
        this.customer.billing_contact_name = this.customer.admin_contact_name;
      }
    },
    'customer.admin_contact_phone'() {
      if (this.use_admin_for_billing) {
        this.customer.billing_contact_phone = this.customer.admin_contact_phone;
      }
    },
    'customer.admin_contact_email'() {
      if (this.use_admin_for_billing) {
        this.customer.billing_contact_email = this.customer.admin_contact_email;
      }
    },
    'customer.name'(new_name, old_name) {
      if (this.customer.id) return; // Return if existing customer
      if (this.slugify(old_name) == this.customer.tenant_name) {
        this.customer.tenant_name = this.slugify(this.customer.name);
      }
    },
    conditions_met() {
      if (this.conditions_met) {
        this.$emit('conditions_met', 'company');
      } else {
        this.$emit('conditions_not_met', 'company');
      }
    }
  }
};
</script>
